import { gql, useMutation } from '@apollo/client';
import useQueryErrorHandler from '../../../../core/hooks/useQueryErrorHandler';
import { QueryStatusData } from 'core/hooks/useQueryHelper';
import { useCallback } from 'react';
import { CancelExtraServiceOrderResponseType, ExtraServiceOrderCancelInput } from '../../../types/extraServiceOrder';

const cancelExtraServiceDocument = gql`
    mutation cancelExtraServiceOrder($serviceData: ExtraServiceOrderCancelInput!) {
        cancelExtraServiceOrder(serviceData: $serviceData) {
            isSuccessful
            message
        }
    }
`;

const useMutationCancelExtraServiceOrder = (): MutationCancelExtraServiceOrderReturnType => {
    const { errorHandler } = useQueryErrorHandler();
    const [cancelRequest, cancelResponse] = useMutation(cancelExtraServiceDocument);

    const cancelExtraServiceOrder = useCallback(
        (serviceData: ExtraServiceOrderCancelInput) =>
            cancelRequest({
                variables: {
                    serviceData,
                },
            }).catch((e) => {
                errorHandler(e);
                throw e;
            }),
        [cancelRequest, errorHandler],
    );

    return {
        response: cancelResponse.data as CancelExtraServiceOrderResponseType | undefined,
        error: cancelResponse.error,
        loading: cancelResponse.loading,
        cancelExtraServiceOrder,
    };
};

export default useMutationCancelExtraServiceOrder;

type MutationCancelExtraServiceOrderReturnType = QueryStatusData & {
    response?: CancelExtraServiceOrderResponseType;
    cancelExtraServiceOrder(serviceData: ExtraServiceOrderCancelInput): Promise<unknown>;
};
